module.exports = __webpack_public_path__ + "img/zhAward-4.abc6f963.png";